// Campus photo for /colleges/university-of-washington: CC BY-SA 4.0, by A.Schneider83, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUW_Red_Square_Suzzallo_Library.JPG), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-washington/; credited under the photo.
const photo = {
    "slug": "university-of-washington",
    "alt": "Suzzallo Library seen across Red Square at the University of Washington in Seattle",
    "src": "/colleges/university-of-washington/campus-1600.webp",
    "srcSmall": "/colleges/university-of-washington/campus-800.webp",
    "srcMid": "/colleges/university-of-washington/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-washington/og.jpg",
    "title": "UW Red Square Suzzallo Library",
    "author": "A.Schneider83",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUW_Red_Square_Suzzallo_Library.JPG",
    "read": "2026-10-02"
};

export default photo;
